package com.essntl.features.contact.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [ContactSupabaseDataSource::class])
internal class ContactSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<ContactDto> {
    override val tableName: String = "contact"
}
